import React, {useState} from 'react';
import LinkButton from "../LinkButton/LinkButton";
import './styles/XMLViewer.scss';

/*
  This component represents one node in an xml tree. It renders the content of its own "root" node, and then recursively
  renders its own children, if any. It is collapsible.
  It takes two arguments: `node`, an XMLDocument object, and `even` a sentinel boolean value which enables alternating
  levels of the tree structure to be rendered in alternating colors.
 */
const XMLNode = ({node, even}) => {
  const name = node.nodeName.trim();
  const content = name.startsWith('#') ? (node.textContent || '').trim() : name;

  const [collapsed, setCollapsed] = useState(false);

  if(!content || content.length === 0) {
    return Array.from(node.childNodes).map((node, idx) => <XMLNode key={idx} node={node}/>);
  }

  return <div className={`xml-viewer-node-content xml-viewer-node-${even ? "even" : "odd"}`}>
    {!name.startsWith('#') && <LinkButton className='xml-toggle-collapse' content={collapsed ? '+' : '–'} onClick={() => setCollapsed(!collapsed)}/>}
    <p>{content}</p>
    {!collapsed && <div className='node-children'>
      {Array.from(node.childNodes).map((node, idx) => {
        return <XMLNode key={idx} node={node} even={!even}/>;
      })}
    </div>}
  </div>;
}

/*
  This component renders a "pretty" viewer for raw xml, with collapsible nodes rendered in alternating, contrasting
  colors to improve readability.
  It takes as its only argument `xml`, an xml document as a string.
 */
const XMLViewer = ({xml}) => {
  const parser = new DOMParser();
  const dom = parser.parseFromString(xml, 'application/xml');

  return <XMLNode node={dom} even={true}/>;
}

export default XMLViewer;
